import { useToastStore } from '../../store/toast-store.js';

/**
 * Renders the toast queue. `bottomOffsetClass` positions the stack above the
 * mobile tab bar (android-app-plan §6.3 — toasts must never hide behind it).
 */
export function ToastHost({ bottomOffsetClass = 'bottom-6' }: { bottomOffsetClass?: string }) {
  const toasts = useToastStore((s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <div
      aria-live="polite"
      className={`pointer-events-none fixed inset-x-0 z-[90] flex flex-col items-center gap-2 px-4 ${bottomOffsetClass}`}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto rounded-full bg-slate-900/90 px-4 py-2 text-sm text-white shadow-lg"
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
